export default __webpack_public_path__ + "static/media/you.781e0ab8.svg";